import React, { Component, } from 'react'
import { SubtestReportTopCard, SubtestReportSkillGroupCard, } from '../AssessReport'
import forOwn from 'mout/object/forOwn'
import assessmentColors from '../../../helpers/assessment/assessmentColors'
import { Card, CardBody, Row, Col, Alert, } from 'reactstrap'
import { AssessSelectorBar, } from '..'
import values from 'mout/object/values'
import has from 'mout/object/has'
import AssessDashTestSummary from '../AssessDashTestSummary'
import getResumeData from '../../../helpers/assessment/getResumeData'
import SubjectNavLinks from '../AssessTest/SubjectNavLinks'
import { BeatLoader } from 'react-spinners'
import checkIfSubtestComplete from '../../../helpers/assessment/checkIfSubtestComplete';
import newSubtestReport from '../../../helpers/assessment/newSubtestReport';
import { NoDataAlert } from '../AssessDash';
import {map} from 'lodash';

/*
AssessmentReportContainer
  <AssessmentReport
    userAssessment={this.props.userAssessment}
    nodes={this.props.nodes}
    subtestId={subtestId}
    subtestReport={this.props.subtestReport}
    user={testUser}
    groupUA={groupUA}
    groupData={groupData}
    assessmentId={assessmentId ? assessmentId : ''}
    groupUAs={this.props.groupUAs}
    selectGroupUA={this.selectGroupUA}
    selectedStudent={selectedStudent}
    selectStudent={this.selectStudent}
    selectedGroupUA={selectedGroupUA}
  />

*/

/**
 * Displays the assessment report, which provides
 * the percentage correct or raw correct for each 
 * skill category.
 */
class AssessmentReport extends Component {

  render() {
    let {state,compareAssismentId,currentAssismentId,isCompare,isCompareState} = this.props
    let uA,uACompare, subtestId, subtest, topTitle, scoresBySubtest,scoresBySubtestCompare, cards = <div></div>
    let firstIncompleteSubtest = null
    let topResume = false
    let topComplete = false
   

    // Compute data needed to display the Resume buttons.
    if (this.props.userAssessment) {
      const resData = getResumeData(this.props.userAssessment)
      if (resData) {
        firstIncompleteSubtest = resData.firstIncompleteSubtest
        topResume = resData.topResume
      }
    }

    // Compute whether or not the top card should be viewed as complete.
    // (It's always in 'complete' mode when we are looking at a groupUA.)
    if (this.props.userAssessment) {
      topComplete = this.props.userAssessment.scoring.byTest.complete === true
    } else if (this.props.selectedGroupUA) {
      topComplete = true
    }

    // If we are looking at a student and have her userAssessment,
    // or if we are looking at a group and have its groupUA...
    if (
      ((this.props.selectedStudent || this.props.user.role === 'Student') && this.props.userAssessment)
      || (this.props.groupUA && this.props.user.role !== 'Student' && !this.props.selectedStudent)
    ) {
      // uA being displayed can either be a userAssessment
      // (if we're looking at an individual student) or a 
      // groupUA (if we're looking at an aggregate).
      // If the user role isn't student, we know we are looking
      // at a student only if this.props.selectedStudent is truthy.
      if (this.props.user.role !== 'Student') {
        if (this.props.selectedStudent) {
          uA = this.props.userAssessment
          uACompare = this.props.userAssessmentCompare
        } else {
          uA = this.props.groupUA
          uACompare = this.props.groupUACompare

        }
      } else {
          uA = this.props.userAssessment
          uACompare = this.props.userAssessmentCompare
      }
      subtestId = this.props.subtestId
      subtest = uA.assessmentSubtests[subtestId]
      scoresBySubtest = uA.scoring.bySubtest[subtestId]
      
      if(uACompare && has(uACompare, 'scoring')){
        scoresBySubtestCompare = uACompare &&  uACompare.scoring.bySubtest && uACompare.scoring.bySubtest[subtestId]
      }
      const { nodes, } = this.props

      // If we have what we need, compute the subtest report 
      // that will be displayed.
      
      let newReport 
      let newReportCompare 
      if (uA && subtestId && nodes) {
        newReport = newSubtestReport(uA.scoring, uA.assessmentSubtests[subtestId], nodes, uA.assessmentSet.maxNodeLevels)
        if(uACompare && has(uACompare, 'scoring')){
        newReportCompare = uACompare ? newSubtestReport(uACompare.scoring, uACompare.assessmentSubtests[subtestId], nodes, uACompare.assessmentSet.maxNodeLevels) : null
        }
      }





     
     
      if(newReportCompare && newReportCompare !== null && newReportCompare.report){
       
        map(newReportCompare.report,(node,i)=>{
        
            map(node,(rD, ir)=>{
              newReport.report[i][ir].percent1 =  rD.percent
            })


        })
      }

      // Set the color based on the subtest subject.
      let color = 'warning'
      if (subtest) {
        color = assessmentColors(subtest.displayName, false)
      }

      // Make the SubtestReportSkillGroupCards for each 'report'
      // inside newReport
      cards = []
      if (newReport) {
        forOwn(newReport.report, (val, key, o) => {
          if (val.length > 0) {
            cards.push(
              <Col xs='12' md='6' xl='3' key={`SubtestReportSkillGroupCard${key}`}>
                <SubtestReportSkillGroupCard
                  report={val}
                  title={val[0] ? val[0].name : ''}
                  color={color}
                  props = {this.props}
                  routeParams = {this.props.routeParams}
                  query = {this.props.query}
                  isCompare = {isCompare}
                  user={this.props.user}
                  assessmentId = {this.props.assessmentId}
                  isSwap = {this.props.isSwap}
                />
              </Col>
            )
          }
        })
      }
      if (cards === []) {
        cards = <div></div>
      }
    }

    // The top title is the subtest displayName, followed by
    // the assessment displayName.
    topTitle = `${subtest ? subtest.displayName : ''} (${uA ? uA.assessmentSet.displayName : ''})`

    let assessSelectorBar = null
    const selectHeaderStye = {
      display: 'flex',
    flexWrap: 'wrap',
    marginTop: '-21px',
    
    }
    // Makes sure we have the data we need on districts, schools,
    // educators, and students. If we do, and if user is an
    // educators, display AssessSelectorBar.
    const groupDataCheck = (
      !!this.props.groupData.districts &&
      !!this.props.groupData.schools &&
      !!this.props.groupData.schools &&
      !!this.props.groupData.educators &&
      !!this.props.groupData.students
    )
    if (this.props.user.role !== 'Student' && groupDataCheck && this.props.selectedGroupUA) {
      assessSelectorBar = (
        <div style={selectHeaderStye}>
          <AssessSelectorBar
            selectedGroupUA={this.props.selectedGroupUA}
            groupUAs={this.props.groupUAs}
            groupData={this.props.groupData}
            assessmentId={this.props.assessmentId}
            role={this.props.user.role}
            selectGroupUA={this.props.selectGroupUA}
            selectStudent={this.props.selectStudent}
            selectedStudent={this.props.selectedStudent}
            updatingGUA={this.props.updatingGUA}
            year={this.props.year}
          />
        </div>
      )
    }

    // Checks if user is educator and all records have been loaded but 
    // appropriate GUA is falsy. This is different situation than if
    // data hasn't loaded yet.
    const nullGUACheck = !(this.props.user.role !== 'Student' && groupDataCheck && !this.props.groupUA)

    // computes alert for missing data.
    let alert = null
    let alertReport = false;
    let needAlert = ''
    const props = this.props
    if (props.user.role !== 'Student' && !this.props.isFetchingGroupUAs) {
      if (props.user.role !== 'Student') {
        if (props.selectedStudent && props.userAssessment) {
          if (has(props.userAssessment, `answersByItem.${props.subtestId}`)) {
            if (values(props.userAssessment.answersByItem[props.subtestId]).length < 1) {
              needAlert = 'Student'
            }
          } else {
            needAlert = 'Student'
          }
        } else if (props.groupUA) {
          if (props.groupUA.answersByItem[props.subtestId]) {
            if (values(props.groupUA.answersByItem[props.subtestId]).length < 1) {
              needAlert = 'Group'
            }
          } else {
            needAlert = 'Group'
          }
        } else {
          needAlert = 'Group'
        }
      }
      
      if (needAlert === 'Student') {
        alert = (
          <Col xs='12' xl='12'>
            <Alert color='warning'>This student has not taken this test, yet.</Alert>
          </Col>
        )
        alertReport = true
      } else if (needAlert === 'Group') {
        alert = (
          <Col xs='12' xl='12'>
            <Alert color='warning'>No selected students have taken this test, yet.</Alert>
          </Col>
        )
        alertReport = true
      }
    }

    // Creates an object used by many subcomponents with data on scoring
    // and assessments. Conditional based on user role and whether we're
    // viewing a student or group.
    let gUA ;
    let gUACompare
    if (
      has(props.user, `role`) &&
      props.user.role !== "Student" &&
      props.selectedGroupUA &&
      props.groupUAs &&
      props.groupUAs[props.selectedGroupUA]
    ) {
      if (props.groupUAs[props.selectedGroupUA][this.props.year]) {        
        gUA = props.groupUA
        gUACompare = props.groupUACompare 
      }
    }
    let sumData1 = {};
    if (this.props.userAssessment && this.props.user.role === "Student") {
      sumData1.userAssessmentId = this.props.userAssessment.userAssessmentId;
      sumData1.scoring = this.props.userAssessment.scoring;
      sumData1.subtests = this.props.userAssessment.assessmentSubtests;
    } else if (this.props.userAssessment && this.props.selectedStudent) {
      sumData1.userAssessmentId = this.props.userAssessment.userAssessmentId;
      sumData1.scoring = this.props.userAssessment.scoring;
      sumData1.subtests = this.props.userAssessment.assessmentSubtests;
    } else if (gUA) {
      sumData1.groupUAId = this.props.selectedGroupUA;
      sumData1.scoring = gUA.scoring;
      sumData1.subtests = gUA.assessmentSubtests;
    }

    let sumDataCompare1 = {};
    if (this.props.userAssessment && this.props.user.role === "Student") {
      sumDataCompare1.userAssessmentId = this.props.userAssessmentCompare && this.props.userAssessmentCompare.userAssessmentId;
      sumDataCompare1.scoring = this.props.userAssessmentCompare && this.props.userAssessmentCompare.scoring;
      sumDataCompare1.subtests = this.props.userAssessmentCompare && this.props.userAssessmentCompare.assessmentSubtests;
    } else if ((this.props.userAssessment) && this.props.selectedStudent) {
      sumDataCompare1.userAssessmentId = this.props.userAssessmentCompare && this.props.userAssessmentCompare.userAssessmentId;
      sumDataCompare1.scoring = this.props.userAssessmentCompare && this.props.userAssessmentCompare.scoring;
      sumDataCompare1.subtests = this.props.userAssessmentCompare && this.props.userAssessmentCompare.assessmentSubtests;
    } else if (gUACompare) {
      sumDataCompare1.groupUAId = this.props.selectedGroupUACompare && this.props.selectedGroupUACompare;
      sumDataCompare1.scoring = gUACompare.scoring;
      sumDataCompare1.subtests = gUACompare.assessmentSubtests;
    }
    
  let sumData = {};
  let sumDataCompare ={};
  let swapArray
    
  if(this.props.isSwap ){
      sumData = sumDataCompare1;
      sumDataCompare =sumData1;
      
    }else{
      sumData = sumData1;
      sumDataCompare =sumDataCompare1;
    }
    let scores ;
    let scoresCompare;

    subtestId = this.props && this.props.subtestId
    subtest = uA && uA.assessmentSubtests && uA.assessmentSubtests[subtestId]
    scores = sumData.scoring && sumData.scoring.bySubtest[subtestId]
    scoresCompare = sumDataCompare && sumDataCompare.scoring && sumDataCompare.scoring.bySubtest && sumDataCompare.scoring.bySubtest[subtestId]
   
    // Computes link path for export to PDF button.
    let printPath
    const year = this.props.year
    let yearQuery = ''

    if(year) yearQuery = `&y=${year}` 
    if (this.props.userAssessment && this.props.user.role === 'Student') {
      printPath = `/assessment/print/${this.props.userAssessment.userAssessmentId}${year ? '?y='+ year : ''}`
    } else {
      printPath = `/assessment/print/${sumData.groupUAId}?g=true&a=${this.props.assessmentId}${yearQuery}`
    }

    // Has the test been completed yet? The subtest report should
    // not display for an individual student if the subtest has
    // not been completed.
    const { user, userAssessment, initializing, } = this.props
    const { role } = user
    let subtestComplete = true
    if (role === 'Student' && userAssessment) {
      subtestComplete = checkIfSubtestComplete(userAssessment, subtestId)
    }
    return (
     <div>
      {assessSelectorBar}
      <Row>
        {props.loadingError &&  <Col><Alert>Error loading. Please check your internet connection and try again.</Alert></Col>}
       
       
        {(nullGUACheck || initializing) &&
          <AssessDashTestSummary
            sm='12' md='12' lg='12' xl='12'
            sub={false}
            topTitle={topTitle}    // might be wrong
            subtest={firstIncompleteSubtest}
            topResume={topResume}
            userAssessmentId={sumData.userAssessmentId ? sumData.userAssessmentId : ''}
            groupUAId={sumData.groupUAId ? sumData.groupUAId : ''}
            groupUAIdCompare={sumDataCompare.groupUAId ? sumDataCompare.groupUAId : ''}
            scoring={sumData.scoring}
            subtests={sumData.subtests}
            topComplete={topComplete}
            assessmentId={this.props.assessmentId}
            selectedGroupUA={this.props.selectedGroupUA}
            selectedStudent={this.props.selectedStudent}
            isStudent={this.props.user.role === 'Student'}
            needAlert={needAlert}
            groupUA={this.props.groupUA}
            userAssessment={this.props.userAssessment}
            user={this.props.user}
            activeSubtest={subtest ? subtest.setId : ''}
            printPath={printPath}
            notInitializing={!initializing}
            routeParams = {this.props.routeParams}
            query = {this.props.query}
            scoringCompare={sumDataCompare && sumDataCompare.scoring}
            isCompare = {this.props.isCompare}
            test1 = {this.props.test1}
            test2 = {this.props.test2}
            isSwap = {this.props.isSwap}
          />
        }
        <Col xs='12' xl='12'>
          {sumData && subtest && 
            <Card>
              <div className="skill-report-nav">
                <SubjectNavLinks
                  subtests={sumData.subtests}
                  uAid={props.routeParams.userAssessmentId}
                  query={props.query}
                  activeSubtest={props.subtestId}
                  reportsRoute={true}
                />
              </div>
              <CardBody>
             {(alertReport===false)?
              <div>
              {subtestComplete?
                <SubtestReportTopCard
                  title={topTitle}
                  scores={scores}
                  subject={subtest ? subtest.displayName : ''}
                  isStudent={this.props.user.role === 'Student'}
                  query = {this.props.query}
                  routeParams = {this.props.routeParams}
                  scoresCompare = {scoresCompare}
                  isCompare = {this.props.isCompare}
                  test1 = {this.props.test1}
                  test2 = {this.props.test2}
                  isSwap = {this.props.isSwap}

                />:
                <div></div>
              }
                {subtestComplete
                  ? <Row className='skill-container'>
                      {cards}
                      {cards.length === 0 &&
                        <Col><BeatLoader loading={initializing} /></Col>
                      }
                    </Row>
                  : <Alert>You have not completed this subtest, yet.</Alert>
                }</div>
                :<div>{alert}</div>
                }
              </CardBody>
            </Card>
          }
          <NoDataAlert 
            role={this.props.user.role}
            scoring={sumData.scoring}
            notInitializing={!initializing}
            selectedStudent={this.props.selectedStudent}
            userAssessment={this.props.userAssessment}
            groupUA={this.props.groupUA}
          />
          {(!sumData) &&
            <Card>
              <CardBody>
                <BeatLoader loading={initializing}/>
              </CardBody>
            </Card>
          }
        </Col>
      </Row>
      </div>
    )
  }
}

export default AssessmentReport


// WEBPACK FOOTER //
// ./src/components/Assessment/AssessReport/AssessmentReport.js